import React, { FC, ReactElement } from 'react';
import styles from './index.less';

interface IProps {
  name?: string,
  enName?: string,
  className?: string
}

const CommonTitle: FC<IProps> = (props:IProps): ReactElement => {

  const { name, enName, className } = props

  return (
    <div className={`${styles.commonTitle} ${className}`}>
      <div className={styles.cn}>
        <span className={styles.left}></span>
        <span className={styles.center}>{name}</span>
        <span className={styles.right}></span>
      </div>
      <div className={styles.en}>{enName}</div>
    </div>
  )
}

export default CommonTitle